import { useState } from "react";

interface ToastProps {
    open: boolean;
    severity: "success" | "error" | "warning" | "info";
    text: string;
}

const defaultToast: ToastProps = {
    open: false,
    severity: "success",
    text: "",
};

export function useToast() {
    const [toast, setToast] = useState<ToastProps>(defaultToast);

    function updateToast(values: Partial<ToastProps>) {
        const newToast = { ...defaultToast, ...toast, ...values };
        setToast({ ...newToast, open: true });
    }

    function closeToast() {
        setToast({ ...toast, open: false });
    }

    return { toast, updateToast, closeToast };
}
